import { Component, OnInit } from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ConfirmationService, MessageService } from "primeng/api";
import { Routes } from "@angular/router";
import { LeavesComponent } from "../leaves/leaves.component";
import { LeaveBalancesComponent } from "../leave-balances/leave-balances.component";
import { BehaviorSubject, Subscription } from "rxjs";
import { CalendarOptions } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Leave } from "src/app/_share/_models/leave";
import { LeaveService } from "src/app/_share/_services/leave.service";
import { EmployeeService } from "src/app/_share/_services/employee.service";
import { HttpClient } from "@angular/common/http";
import { HolidaysService } from "src/app/_share/_services/holiday.service";
import { Holiday } from "src/app/_share/_models/holiday";

@Component({
  selector: "app-policies",
  templateUrl: "./policies.component.html",
  styleUrls: ["./policies.component.scss"],
  providers: [ConfirmationService, MessageService],
})
export class policiesComponent implements OnInit {
  constructor(
    public dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    public employeeService: EmployeeService,
    private leaveService: LeaveService,
    // private http: HttpClient,
    private holidaysService: HolidaysService
  ) {}
  routes: Routes = [
    {
      path: "policies",
      component: policiesComponent,
    },
    {
      path: "leaves",
      component: LeavesComponent, // Component for managing leaves
    },
    {
      path: "leaveBalances",
      component: LeaveBalancesComponent, // Component for leave balances
    },
    { path: "", redirectTo: "/leaveBalances", pathMatch: "full" }, // Default route
  ];
  selectedDate: Date | null = null;
  leaveDays: Array<{ date: Date; title: string }> = [
    { date: new Date("2025-03-10"), title: "Sick Leave" },
    { date: new Date("2025-03-15"), title: "Annual Leave" },
  ];
  employees: any[] = [];
  policies$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  ref: DynamicDialogRef | undefined;
  leavesBalances: any[] = [];
  leavesBalancesObservable$: any;
  private subscriptions: Subscription = new Subscription();
  calendarOptions: CalendarOptions | undefined;
  leaves: Leave[] = [];
  public holidays: Holiday[] = [];

  ngOnInit(): void {
    // this.loadHolidays();
    this.loadEmployees();
    this.holidaysService.getPublicHolidays().subscribe(
      (holidays: Holiday[]) => {
        // console.log("Fetched holidays:", holidays); // Log the holidays data
        if (holidays && holidays.length > 0) {
          this.holidays = holidays; // Set holidays if fetched
        } else {
          console.log("No holidays found.");
        }

        // Handle leave events
        this.leaveService.getLeaves().subscribe((leaves) => {
          const approvedLeaves = leaves.filter(
            (leave) => leave.leave_status === "approved"
          );

          const holidayEvents = holidays.map((holiday) => ({
            title: holiday.summary,
            start: holiday.start_date,
            // start: new Date(holiday.start_date), causes 2a error
            backgroundColor: "grey",
            textColor: "white",
          }));

          const leaveEvents = approvedLeaves.map((leave) => {
            const employeeName = this.getEmployeeNameById(leave.employee_id);
            return {
              title: `${employeeName} -  ${leave.leave_action_type}`,
              start: leave.start_period,
              end: leave.end_period,
              backgroundColor: this.getLeaveTypeColor(
                leave.leave_action_type.toString()
              ),
              textColor: "white",
            };
          });

          // Combine holiday and leave events into one array
          const allEvents = [...holidayEvents, ...leaveEvents];

          console.log("Holiday Events:", holidayEvents);
          console.log("Leave Events:", leaveEvents);
          // Update the calendar options with the event source function
          this.calendarOptions = {
            initialView: "dayGridMonth",
            plugins: [dayGridPlugin, interactionPlugin],
            events: allEvents,
            headerToolbar: {
              left: "prev,next today",
              center: "title",
            },
            height: "680px",
          };

          setTimeout(() => {
            this.policies$.next(false);
          }, 1000);
        });
      },
      (error) => {
        console.error("Error fetching holidays:", error);
      }
    );
  }

  loadEmployees() {
    this.employeeService.getEmployees().subscribe((employees) => {
      this.employees = employees;
    });
  }

  getEmployeeNameById(id: number): string {
    // Find employee by ID and return their full name
    const employee = this.employees.find((emp) => emp.id === id);
    return employee
      ? `${employee.employee_code} ${employee.first_name} ${employee.last_name}`
      : "loading...";
  }

  getLeaveTypeColor(leaveType: string): string {
    switch (leaveType) {
      case "Sick":
        return "green";
      case "Annual":
        return "red";
      case "Maternity":
        return "light blue";
      case "Study":
        return "blue";
      case "Family Responsibility":
        return "purple";
      case "Unpaid":
        return "orange";
      default:
        return "gray";
    }
  }
}
